import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AcceptInvite from "@/pages/AcceptInvite";
import Dashboard from "@/pages/Dashboard";
import Projects from "@/pages/Projects";
import TrashProjects from "@/pages/TrashProjects";
import ProjectDetail from "@/pages/ProjectDetail";
import Vendors from "@/pages/Vendors";
import CostLibrary from "@/pages/CostLibrary";
import Quotations from "@/pages/Quotations";
import VendorComparison from "@/pages/VendorComparison";
import Team from "@/pages/Team";
import Activity from "@/pages/Activity";
import Settings from "@/pages/Settings";
import ClientPortal from "@/pages/ClientPortal";
import Pricing from "@/pages/Pricing";
import BillingSuccess from "@/pages/BillingSuccess";
import AdminSubscriptions from "@/pages/AdminSubscriptions";
import Layout from "@/components/Layout";

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="h-screen w-full flex items-center justify-center">
        <div className="label-caps animate-pulse">Loading BuildTrack…</div>
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  if (user.role === "viewer") return <Navigate to="/portal" replace />;
  return <Layout>{children}</Layout>;
}

function ViewerRoute({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="h-screen w-full flex items-center justify-center">
        <div className="label-caps animate-pulse">Loading…</div>
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function ProtectedBare({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="h-screen w-full flex items-center justify-center">
        <div className="label-caps animate-pulse">Loading BuildTrack…</div>
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function PublicRoute({ children }) {
  const { user } = useAuth();
  if (user && user !== null && user !== false) return <Navigate to={user.role === "viewer" ? "/portal" : "/dashboard"} replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
            <Route path="/register" element={<PublicRoute><Register /></PublicRoute>} />
            <Route path="/forgot-password" element={<PublicRoute><ForgotPassword /></PublicRoute>} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/accept-invite" element={<AcceptInvite />} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/portal" element={<ViewerRoute><ClientPortal /></ViewerRoute>} />
            <Route path="/projects" element={<ProtectedRoute><Projects /></ProtectedRoute>} />
            <Route path="/trash" element={<ProtectedRoute><TrashProjects /></ProtectedRoute>} />
            <Route path="/projects/:id" element={<ProtectedRoute><ProjectDetail /></ProtectedRoute>} />
            <Route path="/vendors" element={<ProtectedRoute><Vendors /></ProtectedRoute>} />
            <Route path="/cost-library" element={<ProtectedRoute><CostLibrary /></ProtectedRoute>} />
            <Route path="/quotations" element={<ProtectedRoute><Quotations /></ProtectedRoute>} />
            <Route path="/best-price" element={<ProtectedRoute><VendorComparison /></ProtectedRoute>} />
            <Route path="/team" element={<ProtectedRoute><Team /></ProtectedRoute>} />
            <Route path="/activity" element={<ProtectedRoute><Activity /></ProtectedRoute>} />
            <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
            <Route path="/pricing" element={<ProtectedBare><Pricing /></ProtectedBare>} />
            <Route path="/billing/success" element={<ProtectedBare><BillingSuccess /></ProtectedBare>} />
            <Route path="/admin/subscriptions" element={<ProtectedRoute><AdminSubscriptions /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
